import { FaqEntryResp } from 'types/api/response/faq-entry-resp'

import { api } from './api'

export const getFaqEntryById = (id: string) => api.get<FaqEntryResp, unknown>(`/faq_entries/${id}`)
